import { gql } from "@apollo/client";

export const getBalanceQuery=gql`
query getBalance($_eq: String = "", $date: timestamptz = "") {
  gogas_user_profile(where: {phone_number: {_eq: $_eq}}) {
    gogas_wallets {
      balance
    }
    id
    name
    phone_number
    vehicle_number
    vehicle_type
    discount_percentage
    user_type
    discount
    maxCap
    max_freq
  }
  gogas_wallet_transactions_aggregate(where: {phone_number: {_eq: $_eq}, created_at: {_gt: $date}}) {
    aggregate {
      count
    }
  }
}
`